/** Frozen peer/group identity for the active call (survives chat switches). */

export type CallPeerSnapshot = {
  title: string;
  avatar: string;
  chatId: number;
  chatType: string;
};

export function setCallPeerSnapshot(snap: {
  title?: string | null;
  avatar?: string | null;
  chatId?: number | string | null;
  chatType?: string | null;
}) {
  try {
    const title = String(snap.title || "").trim();
    const avatar = String(snap.avatar || "").trim();
    const chatId = Number(snap.chatId || 0);
    const chatType = String(snap.chatType || "").trim();
    if (title) sessionStorage.setItem("call_title", title);
    if (avatar) sessionStorage.setItem("call_avatar", avatar);
    if (chatId > 0) sessionStorage.setItem("chat_id", String(chatId));
    if (chatType) sessionStorage.setItem("call_chat_type", chatType);
  } catch {
    /* ignore */
  }
}

export function getCallPeerSnapshot(): CallPeerSnapshot {
  try {
    return {
      title: sessionStorage.getItem("call_title")?.trim() || "",
      avatar: sessionStorage.getItem("call_avatar")?.trim() || "",
      chatId: Number(sessionStorage.getItem("chat_id") || 0),
      chatType: sessionStorage.getItem("call_chat_type")?.trim() || "",
    };
  } catch {
    return { title: "", avatar: "", chatId: 0, chatType: "" };
  }
}
